<template>
    <v-select
        v-model="selected"
        multiple
        class="bg-white"
        label="title"
        :placeholder="placeholder"
        :options="options"
        :append-to-body="appendToBody"
        @input="onChange"
    />
</template>

<script>
import vSelect from 'vue-select'
import axios from '@axios'

export default {
    components: {
        vSelect
    },
    props: {
        options: {
            default() {
                return []
            },
        },
        placeholder: {
            default() {
                return this.$t('Component(Grid):column-select-value')
            }
        },
        initialValue: {
            default() {
                return []
            }
        },
        appendToBody: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            selected: this.initialValue,
            timer: null
        };
    },
    methods: {
        onChange() {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                this.$emit('filter', this.selected);
            }, 600);
        }
    },
}
</script>
